import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Interactable } from 'LocalGluons';
import { Text } from 'react-native';
import { DROPDOWN_PICKER_ITEM_TEST_ID } from '../constants';

const Item = ({ onPress, label, value, onValueChange, index }) => {
    const [focused, setFocused] = useState(false);
    const onButtonPress = () => {
        if (onValueChange) {
            onValueChange(value, index);
        }
        onPress();
    };
    return (
        <Interactable
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            hasTVPreferredFocus={index === 0}
            onPress={onButtonPress}
            testID={DROPDOWN_PICKER_ITEM_TEST_ID}
            style={{ opacity: focused ? 0.6 : 1 }}
        >
            <Text numberOfLines={1} style={{ color: '#85adea', alignSelf: 'flex-start' }}>
                {label}
            </Text>
        </Interactable>
    );
};

Item.defaultProps = {
    onPress: () => {},
    label: '',
    value: '',
    index: 0,
    onValueChange: () => {}
};

Item.propTypes = {
    onPress: PropTypes.func,
    label: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    onValueChange: PropTypes.func
};

export default Item;
